import FranchiseContactUsList from "./components/FranchiseContactUsList";

export default function InterestSubmittedList() {
  return (
    <FranchiseContactUsList
      cityParam="others"
      deletePath="healthsy-pharmacy/home-contact-us"
      pagePath="/franchise-programme/contact-us"
      breadcrumbSecond="Contact Us"
    />
  );
}
